import angular from 'angular';
import AutoGrowInputDirective from './autogrow-input/autogrow-input';
import AutoGrowInputService from './autogrow-input/autogrow-input.service';
import ContentSelectorDirective from './content-selector/ws-content-selector';
import CurrencyDirective from './ws-currency/ws-currency';
import IntegerDirective from './ws-currency/ws-integer';
import TwoDecimalDirective from './ws-currency/ws-two-decimal';
import WsContenteditableDirective from './contenteditable';
import WsDatePickerComponent from './ws-date-picker';
import WsDatePickerService from './ws-date-picker/ws-date-picker.service';
import wsDropdownSelectComponent from './ws-dropdown-select';
import WsInputPillsComponent from './ws-input-pills';
import WsValidationMessagesComponent from './validation/ws-validation-messages.component';
import WsValidatorService from './validation/ws-validator.service';

const injectorName = 'ws.common.form';
export default injectorName;

angular.module(injectorName, ['720kb.datepicker', 'ngMessages'])
  .directive('autogrowInput', AutoGrowInputDirective)
  .service('autogrowInputService', AutoGrowInputService)
  .directive('wsContentSelector', ContentSelectorDirective)
  .directive('wsCurrency', CurrencyDirective)
  .directive('wsInteger', IntegerDirective)
  .directive('wsTwoDecimal', TwoDecimalDirective)
  .directive('wsContenteditable', WsContenteditableDirective)
  .component('wsDatePicker', WsDatePickerComponent)
  .component('wsValidationMessages', WsValidationMessagesComponent)
  .component('wsDropdownSelect', wsDropdownSelectComponent)
  .component('wsInputPills', WsInputPillsComponent)
  .service('wsDatePickerService', WsDatePickerService)
  .service('wsValidatorService', WsValidatorService);



// WEBPACK FOOTER //
// ./src/form/index.js